import { render, staticRenderFns } from "./handers.vue?vue&type=template&id=23ea51a2&scoped=true"
import script from "./handers.vue?vue&type=script&lang=js"
export * from "./handers.vue?vue&type=script&lang=js"
import style0 from "./handers.vue?vue&type=style&index=0&id=23ea51a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea51a2",
  null
  
)

export default component.exports